module.exports = __webpack_public_path__ + "media/images/my_apps/bio_ios_app icon_115_round-2d2652642bf71602130a4ea84705e4bd.png";